<template>
  <div class="paypage">
<!--    <div :class="show ? 'mengban' : ''"> -->
      <div class="paypagetop">
        <div class="paypagecarno">车牌：{{orderDetail.car_no}}</div>
      </div>
      <div class="paypagedetail">
        <div class="paypagetitle">订单详情</div>
        <div class="paypagebottom">
          <div class="paypagedetailbox">
            <div class="paypagetext">预约地址：</div>
            <div class="paypagetext">{{orderDetail.address}}</div>
          </div>
          <div class="paypagedetailbox">
            <div class="paypagetext">预约时间：</div>
            <div class="paypagetext">{{orderDetail.book_time}}</div>
          </div>
          <div class="paypagedetailbox">
            <div class="paypagetext">联系人：</div>
            <div class="paypagetext">{{orderDetail.username}}</div>
          </div>
          <div class="paypagedetailbox">
            <div class="paypagetext">支付状态：</div>
            <div class="paypagestatus">{{orderDetail.pay_status_str}}</div>
          </div>
          <div class="paypagedetailbox">
            <div class="paypagetext">订单状态：</div>
            <div class="paypagestatus">{{orderDetail.status_str}}</div>
          </div>
        </div>
      </div>
      <div class="paypagebotton" v-if="showbotton" @click="buttonClicked ? '' : topay()">立即支付</div>
 <!--   </div> -->
  </div>
</template>

<script>
  import httper from '../../api/http';
  import {
    Dialog
  } from 'vant';
  import {
    Toast
  } from 'vant';
  const openLoading = () => {
    Toast.loading({
      message: "加载中",
      duration: 0, // toast不消失
    });
  }
  export default {
    data() {
      return {
        userInfo: {}, //接口获取用户信息
        order_no: "",
        orderDetail: {},
        showbotton: true,
        show: false,
        buttonClicked:false,
      }
    },
    created() {
      this.order_no = this.getQueryString("order_no")
      this.request("tucarorder", {
        order_no: this.order_no
      })
    },
    methods: {
      getQueryString(name) {
        let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        if (window.location.hash.indexOf("?") < 0) return null;
        let r = window.location.hash.split("?")[1].match(reg);
        if (r != null) return decodeURIComponent(r[2]);
        return null;
      },
      /**
       * 防重点击
       * @param duration
       * @returns {Promise<any>}
       */
      buttonClickedFun(duration = 0) {
        this.buttonClicked = true
        return new Promise((resolve, reject) => {
          if (duration && typeof duration === 'number') {
            setTimeout(() => {
              this.buttonClicked = false
            }, duration)
          }
          resolve(true)
        })
      },
      //下单
      topay() {
        // let order_param = {}
        // order_param.pay_type = 'wechatpay'
        // order_param.recover_no = this.recover_no
        this.buttonClickedFun(5000)
        let that = this
        openLoading()
        Dialog.confirm({
            title: '提示',
            message: '确认支付？',
          })
          .then(() => {
            that.request("tucarunified", {
              order_no: that.order_no
            })
            that.show = true
          })
          .catch(() => {
            return false;
          });
      },
      //调用接口
      request(type = '', requestData = {}) {
        let that = this
        switch (type) {
          case 'tucarorder':
            httper.get('tu-car/order-detail', requestData, res => {
              if (res.code == 0) {
                this.orderDetail = res.data
                if(this.orderDetail.pay_status==1){
                  that.showbotton = false
                }else{
                  that.showbotton = true
                }
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
          case 'tucarunified':
            httper.post('tu-car/unified-order', requestData, res => {
              if (res.code == 0) {
                setTimeout(() => {
                  Toast.clear();
                }, 500)
                that.pay(res.data.payment_packet, res.data.order_no)
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
        }
      },
      //发起支付
      pay(payment_packet, order_no) {
        if (typeof WeixinJSBridge == "undefined") {
          if (document.addEventListener) {
            document.addEventListener('WeixinJSBridgeReady', this.jsApiCall(payment_packet, order_no), false);
          } else if (document.attachEvent) {
            document.attachEvent('WeixinJSBridgeReady', this.jsApiCall(payment_packet, order_no));
            document.attachEvent('onWeixinJSBridgeReady', this.jsApiCall(payment_packet, order_no));
          }
        } else {
          this.jsApiCall(payment_packet, order_no);
        }
      },
      //调用微信支付
      jsApiCall(payment_packet, order_no) {

        let that = this
        if (!payment_packet) {
          this.$toast({
            message: '下单失败，请重试',
          })
          return
        }
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest', payment_packet,
          function(res) {
            if (res.err_msg == "get_brand_wcpay_request:ok") {
              //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠
              //跳去详情页order_no
              that.showbotton = false
              that.$toast({
                message: '支付成功！'
              })
              that.request("tucarorder", {
                order_no: that.order_no
              })
            } else {
              this.$toast({
                message: '支付失败',
              })
            }
          }
        )
      },

    }
  }
</script>

<style scoped="scoped">
  .paypage {
    background-color: #F5F5F5;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  .paypagetop {
    width: calc(100% - 40px);
    margin: 20px;
    background-color: #FFFFFF;
    border-radius: 8px;
    height: 48px;
    padding: 0 20px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }

  .paypagecarno {
    font-size: 15px;
    font-weight: 600;
  }

  .paypagedetail {
    width: calc(100% - 40px);
    margin: 20px;
    padding: 20px;
    box-sizing: border-box;
    background-color: #FFFFFF;
    border-radius: 8px;
  }

  .paypagetitle {
    width: 100%;
    padding-bottom: 10px;
    margin-bottom: 10px;
    border-bottom: 1px solid #D2D2D2;
    font-size: 15px;
    font-weight: 500;
  }

  .paypagebottom {
    width: 100%;
    padding: 0 10px;
    box-sizing: border-box;
  }

  .paypagedetailbox {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }

  .paypagetext {
    font-size: 15px;
    color: #666666;
  }

  .paypagestatus {
    font-size: 15px;
    color: #FF7608;
  }

  .paypagebotton {
    width: calc(100% - 40px);
    margin: 20px;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    color: #FFFFFF;
    background-color: #FD8C00;
    border-radius: 8px;
  }

  .mengban {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 9;
    background-color: rgba(0, 0, 0, .5);
  }
</style>



// WEBPACK FOOTER //
// src/pages/xianxia/paypage.vue